import React from "react";
import { useHistory } from "react-router-dom";
import { Grid, Typography } from "@material-ui/core";
import { format } from "date-fns";

export const ProductActivityRow = ({
  displayIndex,
  displayActivities,
  displayGroupId,
}) => {
  const history = useHistory();

  const activeRewards = displayActivities[1].Rewards.filter(
    (item) => item.IsActive === true
  );

  return (
    <Grid
      container
      spacing={6}
      style={{
        marginTop: "1px",
        marginBottom: "0.5rem",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Grid item xs={1}>
        <Typography variant="body1">
          <strong>Product</strong>
        </Typography>
      </Grid>
      {displayIndex && (
        <>
          <Grid item xs={1}>
            <Typography
              variant="body2"
              className="activity-link"
              onClick={() =>
                history.push(
                  `/my-displays-maintenance/${displayGroupId}/${displayIndex}/${displayActivities[1].Activity.Id}`
                )
              }
            >
              {displayActivities[1].Activity.Id}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="body2">
              {displayActivities[1].Activity.Name}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="body2">
              {format(
                new Date(displayActivities[1].Activity.StartDate),
                "dd/MM/yyyy"
              )}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="body2">
              {format(
                new Date(displayActivities[1].Activity.EndDate),
                "dd/MM/yyyy"
              )}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <span
              className={`${
                displayActivities[1].Activity.IsActive
                  ? "active-tag-text"
                  : "inactive-tag-text"
              }`}
            >
              {displayActivities[1].Activity.IsActive ? "Active" : "Inactive"}
            </span>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="body2">
              {displayActivities[1].ActivityDataType.Value}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography
              variant="body2"
              style={{ display: "flex", justifyContent: "center" }}
            >
              {displayActivities[1].Rewards.length === 0 &&
              activeRewards.length === 0
                ? 0
                : Math.max(...activeRewards.map((item) => item.Value))}
            </Typography>
          </Grid>
        </>
      )}
    </Grid>
  );
};
